module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-move-right-42d7ea604b7d14a2868b77e79caf70f0.svg";